import {
  buildDispatchReassignmentModeStorageKey,
  normalizeDispatchReassignmentMode,
} from "./dispatchReassignmentMode.js";
import {
  DISMISSED_UPDATE_STORAGE_KEY,
  parseDismissedUpdateIdsSnapshot,
  serializeDismissedUpdateIds,
} from "./productUpdatesStorage.js";
import {
  ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY,
} from "./routeMapGroupRangePreference.js";
import {
  assertValidUserUiPreferencesPayload,
  resolveUserUiPreferencesUserId,
} from "./userUiPreferences.js";

function getLocalStorage(targetWindow = typeof window !== "undefined" ? window : undefined) {
  try {
    return targetWindow?.localStorage ?? null;
  } catch {
    return null;
  }
}

export function readLegacyUserUiPreferencesPatch(userId, { targetWindow } = {}) {
  const resolvedUserId = resolveUserUiPreferencesUserId(userId);
  const storage = getLocalStorage(targetWindow);
  if (!resolvedUserId || !storage) {
    return {};
  }

  const patch = {};
  try {
    const modeStorageKey = buildDispatchReassignmentModeStorageKey(resolvedUserId);
    const storedMode = storage.getItem(modeStorageKey);
    if (storedMode !== null) {
      patch.dispatch_reassignment_mode = normalizeDispatchReassignmentMode(storedMode);
    }

    const storedGroupRanges = storage.getItem(ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY);
    if (storedGroupRanges !== null) {
      patch.route_map_group_ranges_visible = storedGroupRanges === "1";
    }

    const storedDismissedUpdateIds = storage.getItem(DISMISSED_UPDATE_STORAGE_KEY);
    if (storedDismissedUpdateIds !== null) {
      patch.dismissed_product_update_ids = parseDismissedUpdateIdsSnapshot(storedDismissedUpdateIds);
    }
  } catch {
    return {};
  }
  return patch;
}

export function mirrorConfirmedUserUiPreferencesToLegacy(userId, preferences, {
  targetWindow,
} = {}) {
  const resolvedUserId = resolveUserUiPreferencesUserId(userId);
  const storage = getLocalStorage(targetWindow);
  if (!resolvedUserId || !storage) {
    return false;
  }

  let confirmedPreferences;
  try {
    confirmedPreferences = assertValidUserUiPreferencesPayload(preferences);
  } catch {
    return false;
  }

  try {
    storage.setItem(
      buildDispatchReassignmentModeStorageKey(resolvedUserId),
      confirmedPreferences.dispatch_reassignment_mode,
    );
    if (confirmedPreferences.route_map_group_ranges_visible) {
      storage.setItem(ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY, "1");
    } else {
      storage.removeItem(ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY);
    }
    if (confirmedPreferences.dismissed_product_update_ids.length > 0) {
      storage.setItem(
        DISMISSED_UPDATE_STORAGE_KEY,
        serializeDismissedUpdateIds(confirmedPreferences.dismissed_product_update_ids),
      );
    } else {
      storage.removeItem(DISMISSED_UPDATE_STORAGE_KEY);
    }
    return true;
  } catch {
    return false;
  }
}
